import { EventBus } from '@goodhabitz/learning-activity-communication';
import { isGhccMessage } from './isGhccMessage';
import { transformToActivityMessage } from './transformToActivityMessage';
import { GhccMessageType } from './ghccMessageTypes';
import { ActivityMetrics } from './activityMetrics';
import { sendMetricsToDatadog } from './metricUtils';
let isRegistered = false;
export const registerGhccEvents = (debugMode = false, token) => {
    if (isRegistered)
        return;
    isRegistered = true;
    const eventBus = new EventBus(window.location.origin);
    const activityMetricsInstance = token && ActivityMetrics.getInstance(token, debugMode);
    if (activityMetricsInstance) {
        eventBus.on(GhccMessageType.startActivity, (message) => {
            var _a;
            activityMetricsInstance === null || activityMetricsInstance === void 0 ? void 0 : activityMetricsInstance.onStartActivity((_a = message.payload) === null || _a === void 0 ? void 0 : _a.id);
        });
    }
    eventBus.connect(window);
    window.addEventListener('message', (ghccMessage) => {
        if (!isGhccMessage(ghccMessage))
            return;
        const message = transformToActivityMessage(ghccMessage);
        eventBus.send(message);
        if (activityMetricsInstance) {
            sendMetricsToDatadog(message, activityMetricsInstance);
        }
    });
};
//# sourceMappingURL=registerGhccEvents.js.map